import { SnColorPalette, SnSize } from '@lib/common/types';

import { SnBadgePositionX, SnBadgePositionY } from './badge-position.type';

interface ISnBadgeCommonConfig {
  size?: SnSize;
  color?: SnColorPalette;
  positionX?: SnBadgePositionX;
  positionY?: SnBadgePositionY;
}

interface ISnBadgeValueConfig extends ISnBadgeCommonConfig {
  value: string | number;
}

interface ISnBadgeSmartConfig extends ISnBadgeCommonConfig {
  name: string;
}

export type SnBadgeConfig = string | number | ISnBadgeValueConfig | ISnBadgeSmartConfig;
